import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBqjFQisrnpHJ4BRjVdPyKUWbWS5cFr7MY",
  authDomain: "dou-auto-bidder.firebaseapp.com",
  projectId: "dou-auto-bidder",
  storageBucket: "dou-auto-bidder.firebasestorage.app",
  messagingSenderId: "49207240384",
  appId: "1:49207240384:web:22ffa79eba38514820ef25"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);

export { app, db, auth, functions, storage };
